import { render } from "./DashboardContentLoader.vue?vue&type=template&id=aa738712&scoped=true&ts=true"
import script from "./DashboardContentLoader.vue?vue&type=script&lang=ts"
export * from "./DashboardContentLoader.vue?vue&type=script&lang=ts"

import "./DashboardContentLoader.vue?vue&type=style&index=0&id=aa738712&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa738712"]])

export default __exports__